//
//
//
//
//
//
//
//

export default {
    name: 'MZOverlay',
    props: {
        show: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data() {
        return {}
    },
    methods: {
    }
}



// WEBPACK FOOTER //
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/overlay/index.vue